import { ActionType } from 'typesafe-actions';
import BaseReducer, {
baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import { IBrandType } from '../../types/IBrandType';
import * as brandActions from './brandActions';

export type BrandAction = ActionType<typeof brandActions>;

export interface IBrandStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: IBrandType };
	readonly queries: { [queryKey: string]: IBrandType[] };
}

export function brandReducer(
	state = baseInitialState as IBrandStateType,
	action: BrandAction,
) {
	const Reducer = new BaseReducer('brandReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}
